import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/tidsregistering/balances';

export const balancesAPI = {
  listForStaff: (staffMemberId) => apiClient.get(`${BASE}/staff/${staffMemberId}`),
  setEntitlement: (absenceBalanceId, data) => apiClient.patch(`${BASE}/${absenceBalanceId}/entitlement`, data),
  getSalaryExport: (staffMemberId, periodStart, periodEnd) =>
    apiClient.get(`${BASE}/salary-export/staff/${staffMemberId}`, {
      params: { period_start: periodStart, period_end: periodEnd },
    }),
  seedPeriod: (staffMemberId, asOfDate) =>
    apiClient.post(`${BASE}/seed-period/${staffMemberId}`, null, {
      params: asOfDate ? { as_of_date: asOfDate } : undefined,
    }),
};
